import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { ThemeContext } from './theme.context';

// O painel roda só no tema escuro (design system Aliste-se) — o seletor de tema foi
// removido das telas. Enquanto desligado, ignora o que estiver salvo no localStorage.
const THEME_TOGGLE_ENABLED = false;

const getStoredTheme = (): 'light' | 'dark' => {
  if (!THEME_TOGGLE_ENABLED) return 'dark';

  if (typeof window !== 'undefined') {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark' || savedTheme === 'light') {
      return savedTheme;
    }
  }

  return 'light';
};

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState<'light' | 'dark'>(getStoredTheme);

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }

    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'light' ? 'dark' : 'light'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
